import { GiftCardsApiClient } from '@fourthwall/services/dist/GiftCardsApiClient'
import { createMutationHook } from '@fourthwall/utils/dist/queries'

export const useReactivateGiftCardGroupMutation = createMutationHook(
  GiftCardsApiClient.reactivateGiftCardGroup,
  {
    mutationKey: ['reactivateGiftCardGroup'],
  },
)
